import React from 'react';
import PropTypes from 'prop-types';
import Rater from 'react-rater';
import 'react-rater/lib/react-rater.css';
import './style.css';

const Stars = ({ rating, onRate }) => (
  <div className="rating-system">
    <Rater total={5} rating={rating} onRate={onRate} />
  </div>
);

Stars.propTypes = {
  rating: PropTypes.number.isRequired,
  onRate: PropTypes.func.isRequired,
};

export default Stars;
